import { Flex, Heading } from '@cognite/cogs.js';
import styled from 'styled-components/macro';

export const CommentsHeaderContainer = styled(Flex)`
  padding: 8px;
`;

export const CommentsHeaderTitle = styled(Heading)`
  display: block;
  margin-bottom: 10px;
`;
